import { Result, Button, Typography, Card } from 'antd';
import { StopOutlined, MailOutlined, PhoneOutlined, LogoutOutlined } from '@ant-design/icons';
import { useAuth } from '../contexts/AuthContext';

const { Title, Paragraph, Text } = Typography;

export function DeactivatedAccount() {
  const { firmStatus, logout } = useAuth();

  const handleLogout = () => {
    logout();
    window.location.href = '/login';
  };

  return (
    <div style={{
      minHeight: '100vh',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
      padding: 24,
    }}>
      <Card style={{ maxWidth: 600, width: '100%', textAlign: 'center' }}>
        <Result
          icon={<StopOutlined style={{ color: '#ff4d4f', fontSize: 72 }} />}
          title={
            <Title level={3} style={{ marginBottom: 0 }}>
              Hesabınız Devre Dışı Bırakıldı
            </Title>
          }
          subTitle={
            <Paragraph style={{ fontSize: 16, color: '#666', marginTop: 16 }}>
              Sisteme erişiminiz geçici olarak durdurulmuştur.
            </Paragraph>
          }
          extra={
            <Button
              type="primary"
              icon={<LogoutOutlined />}
              onClick={handleLogout}
              size="large"
            >
              Çıkış Yap
            </Button>
          }
        >
          {firmStatus?.deactivationReason && (
            <div style={{
              background: '#fff1f0',
              border: '1px solid #ffa39e',
              borderRadius: 8,
              padding: 16,
              marginTop: 24,
              textAlign: 'left',
            }}>
              <Text strong style={{ display: 'block', marginBottom: 8 }}>
                Sebep:
              </Text>
              <Paragraph style={{ marginBottom: 0 }}>
                {firmStatus.deactivationReason}
              </Paragraph>
            </div>
          )}

          <div style={{
            background: '#f5f5f5',
            borderRadius: 8,
            padding: 24,
            marginTop: 24,
            textAlign: 'left',
          }}>
            <Title level={5} style={{ marginBottom: 16 }}>
              Yardım Almak İçin
            </Title>
            <Paragraph style={{ marginBottom: 8 }}>
              Hesabınızın yeniden aktifleştirilmesi veya detaylı bilgi için bizimle iletişime geçebilirsiniz:
            </Paragraph>
            <div style={{ display: 'flex', flexDirection: 'column', gap: 8 }}>
              <div>
                <MailOutlined style={{ marginRight: 8, color: '#1890ff' }} />
                <a href="mailto:destek@raporgor.com">destek@raporgor.com</a>
              </div>
              <div>
                <PhoneOutlined style={{ marginRight: 8, color: '#52c41a' }} />
                <a href="tel:+908501234567">0850 123 45 67</a>
              </div>
            </div>
          </div>
        </Result>
      </Card>
    </div>
  );
}
